<template>
  <div class="report_info">
    <div class="row">
      <div class="col-md-6"><fg-input :value="report.name" :label="translate('reports.name')" :readonly="true" /></div>
      <div class="col-md-3"><fg-input :value="report.metric" :label="translate('reports.metric')" :readonly="true" /></div>
      <div class="col-md-3"><fg-input :value="translate('reports.statuses.' + report.status)" :label="translate('reports.status')" :readonly="true" /></div>
    </div>
    <div class="row">
      <div class="col-md-3"><fg-input :value="format_date(report.date_from)" :label="translate('reports.date_from')" :readonly="true" /></div>
      <div class="col-md-3"><fg-input :value="format_date(report.date_to)" :label="translate('reports.date_to')" :readonly="true" /></div>
      <div class="col-md-3"><fg-input :value="report.progress" :label="translate('reports.progress')" :readonly="true" /></div>
      <div class="col-md-3"><fg-input :value="report.format" :label="translate('reports.format')" :readonly="true" /></div>
    </div>
    <div class="row">
      <div class="col-md-3"><fg-input :value="report.client_id" :label="translate('reports.client_id')" :readonly="true" /></div>
      <div class="col-md-3"><fg-input :value="report.owner_user_id" :label="translate('reports.owner_user_id')" :readonly="true" /></div>
      <div class="col-md-3"><fg-input :value="format_date(report.created_at)" :label="translate('reports.created_at')" :readonly="true" /></div>
      <div class="col-md-3"><fg-input :value="format_date(report.finished_at)" :label="translate('reports.finished_at')" :readonly="true" /></div>
    </div>
    <div v-if="report.parameters" class="row">
      <div class="col-md-3"><fg-input :value="report.parameters.period" :label="translate('reports.period')" :readonly="true" /></div>
      <div class="col-md-9"><fg-input :value="(report.parameters.aggregates || []).join(', ')" :label="translate('reports.aggregates')" :readonly="true" /></div>
      <div class="col-md-12 form-group">
        <label>{{ translate('reports.columns') }}</label>
        <textarea class="input_text" rows="4" :value="(report.parameters.columns || []).join('\n')" readonly />
      </div>
      <div v-for="(value, key) in report.parameters.filters" :key="key" class="col-md-6">
        <fg-input :value="Array.isArray(value) ? value.join(', ') : value" :label="key" :readonly="true" />
      </div>
    </div>

    <div v-if="report.file_name" class="row">
      <div class="col-md-9"><fg-input :value="report.file_name" :label="translate('reports.file_name')" :readonly="true" /></div>
      <div class="col-md-3"><fg-input :value="report.file_size_bytes" :label="translate('reports.file_size')" :readonly="true" /></div>
    </div>
    <div class="actions">
      <a v-if="report.file_url" :href="file_url" :download="report.file_name" target="_blank" rel="noopener noreferrer" class="btn btn-success btn-fill">{{ translate('reports.download') }}</a>
    </div>

    <div v-if="report.error_message" class="text-danger">{{ report.error_message }}</div>
  </div>
</template>
<script>
export default {
  name: 'ReportInfo',
  props: { report: { type: Object, required: true } },
  computed: {
    file_url() {
      return this.report.file_url
          ? new URL(this.report.file_url, new URL(process.env.VUE_APP_BASE_URL, window.location.origin)).href
          : ''
    }
  },
  methods: {
    format_date(value) { return value ? this.get_date(value) : '' }
  }
}
</script>
<style lang="scss" scoped>
.report_info {
  height: 100%;
  overflow: auto;
  padding: 10px;
  .actions { display: flex; gap: 10px; margin-bottom: 10px; flex-wrap: wrap; }
  textarea { width: 100%; }
}
</style>
